import React from 'react';
import swal from 'sweetalert';
import styled from 'styled-components';
import moment from 'moment';

import { formatCallTime, imageFix } from "../../../helpers";
import { offer } from '../../../services/api';
import { Row, Col } from '../../Grid';
import { connect } from 'react-redux';
import { checkedIn } from '../../../redux/offers';
import starSpot from '../../../svg/star-spot.svg';
import checkmark from '../../../svg/checkmark.svg';
import posted from "../../../svg/posted.svg";

const AttendeeIcon = styled.div`
  display: block;
  width: 60px;
  height: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-border-radius: 99em;
  -moz-border-radius: 99em;
  border-radius: 99em;
  margin-left: 30px;
  background-size: cover;
  background-position-y: 30%;
  background-image: url(${(props) => props.image});
`;

const BreakLine = styled.div`
  width: 336px;
  height: 1px;
  margin: 20px auto;
  border-bottom: solid 0.5px #bbbbbb;
`;

const Name = styled.div`
  font-family: BrandonGrotesque-Regular;
  text-align: left;
  font-size: 18px;
  color: #333333;
`;

const Instagram = styled.a`
  font-family: BrandonGrotesque-Regular;
  font-size: 16px;
  color: var(--color-gunmetal);
  text-decoration: underline;
  &:hover { color: var(--color-gunmetal); }
`;

const CallTime = styled.div`
  font-family: BrandonGrotesque-Regular;
  text-align: left;
  font-size: 12px;
  color: #999999;
`;
const Status = styled.div`
  font-family: BrandonGrotesque-Regular;
  text-align: left;
  font-size: 12px;
  letter-spacing: 0.4px;
`;

const CheckInButton = styled.div`
  font-family: BrandonGrotesque-Bold;
  width: 60px;
  height: 30px;
  border-radius: 4px;
  background-color: var(--color-gunmetal);
  font-size: 11px;
  text-align: center;
  color: #ffffff;
  line-height: 35px;
  cursor: pointer;
  opacity: ${(props) => (props.allowed ? 1 : 0.4)};
`;

const formatTime = (time: string) => moment.parseZone(time).calendar();

const wording = (status) => {
  switch (status) {
    case 'canceled':
      return (user: Attendee) => (
        <span style={{ color: '#555555' }}>Canceled {formatTime(user.canceled_at)}</span>
      );
    case 'active':
      return (user: Attendee) => null;
    case 'expired':
      return (user: Attendee) => (
        <span style={{ color: '#b71b03' }}>Expired {formatTime(user.expires_at)}</span>
      );
    case 'used':
      return (user: Attendee) => (
        <span style={{ color: '#415859' }}>Checked in {formatTime(user.checked_in_at)}</span>
      );
    case 'incomplete':
      return (user: Attendee) => (
        <span style={{ color: '#415859' }}>Claimed at {formatTime(user.claimed_at)}</span>
      );
    case 'preparing':
      return (user: Attendee) => '';
    case 'shipped':
      return (user: Attendee) => '';
    case 'delivered':
      return (user: Attendee) => (
        <span style={{ color: '#415859' }}>Checked in {formatTime(user.checked_in_at)}</span>
      );
    case 'unknown':
      return (user: Attendee) => null;

    default:
      return (user) => 'Unknown status: ' + status;
  }
};
interface Props {
  attendee: Attendee;
  offerId: string;
  checkedIn: Function;
  checkInReady: boolean;
}

interface State {
  checkingIn: boolean;
}

class AttendeeC extends React.Component<Props, State> {

  constructor(props) {
    super(props);
    this.state = { checkingIn: false };
  }

  checkIn(allowed) {
    if (!allowed) {
      swal('Click this button to check in a model once your offer begins.');
      return;
    }

    this.setState({ checkingIn: true });

    offer.checkIn(this.props.attendee.id || this.props.attendee.claim_id).then((result) => {
      this.setState({ checkingIn: false });
      this.props.checkedIn({
        dealId: this.props.offerId,
        claimId: this.props.attendee.id,
      });
    });
  }

  render() {
    const attendee = this.props.attendee;
    const allowed = moment().isAfter(attendee.starts_at) && moment().isBefore(attendee.ends_at);
    const isActive = attendee.status === 'active';
    const format = (text: string) =>
      isActive ? text.substring(0, 20) + (text.length > 20 ? '...' : '') : text;

    return (
      <>
        <Row>
          <Col size="3">
            <AttendeeIcon image={imageFix(attendee.model.avatar)} />
          </Col>
          <Col size={isActive ? '5' : '8'}>
            <Name>
              {format(attendee.model.name)}

              {attendee.posted_at && <img src={posted} alt="" height={16} width={16} style={{ marginLeft: '10px' }} />}

              {attendee.status === 'used' ? (
                <img src={checkmark} style={{ marginLeft: '5px' }} alt="avatar" />
              ) : null}

              {attendee.spot_type === 'star' ? (
                <img src={starSpot} style={{ marginLeft: '5px' }} alt="avatar" />
              ) : null}
            </Name>
              
            <Instagram target="_blank" href={attendee.model.instagram.profile_url}>
              @{attendee.model.instagram.handle}
            </Instagram>

            {attendee.call_time !== undefined && attendee.call_time !== null
              ? <CallTime>{formatCallTime(attendee.call_time)}</CallTime>
              : null
            }

            <Status>{wording(attendee.status)(attendee)}</Status>
          </Col>
          {this.props.checkInReady ? (
            <Col size="3">
              <CheckInButton onClick={() => this.checkIn(allowed)} allowed={allowed}>
                {this.state.checkingIn ? 'CHECKING IN' : 'CHECK IN'}
              </CheckInButton>
            </Col>
          ) : null}
        </Row>
        <BreakLine />
      </>
    );
  }
}
export default connect(null, { checkedIn })(AttendeeC);

export { AttendeeIcon, Name, BreakLine };
